import BaseClient from './BaseClient';

class CustomAttributesClient extends BaseClient {
    list(teamId, params) {
        const url = `/api/v3/teams/${teamId}/custom-attributes`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    delete(teamId, customAttributeId) {
        const url = `/api/v3/teams/${teamId}/custom-attributes/${encodeURIComponent(customAttributeId)}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    customAttributesAutocomplete($teamId, params, config) {
        const method = 'get';
        const url = `/api/v3/teams/${$teamId}/custom-attributes/autocomplete`;

        return this.makeCoreApiRequest(url, method, null, params, config);
    }

    customAttributesMeta() {
        const url = '/api/custom_attributes_meta';
        return this.makeCoreApiRequest(url);
    }

    localCustomAttributesMeta() {
        const url = '/api/local_custom_attributes_meta';
        return this.makeCoreApiRequest(url);
    }
}

export default new CustomAttributesClient();
